"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("antd/lib/row/style");
var _row = _interopRequireDefault(require("antd/lib/row"));
require("antd/lib/col/style");
var _col = _interopRequireDefault(require("antd/lib/col"));
require("antd/lib/form/style");
var _form = _interopRequireDefault(require("antd/lib/form"));
var _react = _interopRequireWildcard(require("react"));
var _EditableInput = require("../EditableInput");
var _utils = require("../../utils");
var _components = require("../../components");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var fieldName = 'nickName';
var EditableNickName = function EditableNickName(_ref) {
  var form = _ref.form,
    loading = _ref.loading,
    nickName = _ref.nickName,
    onSubmit = _ref.onSubmit;
  var getFieldDecorator = form.getFieldDecorator,
    isFieldValidating = form.isFieldValidating,
    setFieldsValue = form.setFieldsValue;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    isActive = _useState2[0],
    setIsActive = _useState2[1];
  var onEdit = (0, _react.useCallback)(function () {
    return setIsActive(true);
  }, []);
  var validationErrors = Object.values(form.getFieldsError()).some(function (v) {
    return v;
  });
  var isValidating = isFieldValidating(fieldName);
  var handleSubmit = function handleSubmit(e) {
    e.preventDefault();
    form.validateFieldsAndScroll(function (err, values) {
      if (!err && values[fieldName] !== nickName) {
        onSubmit(values).then(function () {
          return setIsActive(false);
        });
      }
    });
  };
  var resetFieldsValue = (0, _react.useCallback)(function () {
    if (nickName) {
      setFieldsValue(_defineProperty({}, fieldName, nickName));
    }
    setIsActive(false);
  }, [nickName, setFieldsValue]);
  return /*#__PURE__*/_react.default.createElement(_form.default, {
    onSubmit: handleSubmit,
    className: "change-nickname-form"
  }, /*#__PURE__*/_react.default.createElement(_form.default.Item, null, getFieldDecorator(fieldName, {
    initialValue: nickName,
    rules: [{
      required: true,
      message: 'Please enter a nickname',
      whitespace: true
    }, {
      pattern: _utils.nickNameRegex,
      message: 'Nickname can contain only alphanumeric and underscore symbols'
    }, {
      pattern: _utils.startsWithLetterRegex,
      message: 'Nickname must start with a letter'
    }, {
      min: 3,
      message: 'Nickname must contain at least 3 characters'
    }, {
      max: 38,
      message: 'Nickname can’t contain more than 38 characters'
    } // eslint-disable-line
    ]
  })( /*#__PURE__*/_react.default.createElement(_EditableInput.EditableInput, {
    active: isActive,
    disabled: !!validationErrors,
    editable: !!onSubmit,
    name: fieldName,
    onEdit: onEdit,
    placeholder: "Nickname (i.e. ".concat(nickName, ")"),
    processing: isValidating,
    saveButton: null
  }))), isActive && /*#__PURE__*/_react.default.createElement(_form.default.Item, null, /*#__PURE__*/_react.default.createElement(_row.default, {
    className: "flex items-baseline"
  }, /*#__PURE__*/_react.default.createElement(_col.default, {
    xs: 12,
    md: 8
  }, /*#__PURE__*/_react.default.createElement(_components.SecondaryButton, {
    htmlType: "submit",
    size: "small",
    disabled: loading || validationErrors || nickName === form.getFieldValue(fieldName)
  }, "Save")), /*#__PURE__*/_react.default.createElement(_col.default, {
    xs: 12,
    md: 8
  }, /*#__PURE__*/_react.default.createElement(_components.TextButton, {
    htmlType: "button",
    disabled: loading,
    size: "small",
    onClick: resetFieldsValue
  }, "cancel")))));
};
var _default = _form.default.create({
  name: 'ChangePassword'
})(EditableNickName);
exports.default = _default;